import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * @description 
 * Utility function for merging Tailwind CSS classes together.
 * This combines the functionality of clsx and tailwind-merge.
 * 
 * clsx handles conditional class application.
 * tailwind-merge handles conflicting Tailwind classes by taking the last one.
 * 
 * @dependencies
 * - clsx: For conditional class application
 * - tailwind-merge: For handling conflicting Tailwind classes
 * 
 * @example
 * cn('px-2 py-1', 'bg-red-500', { 'text-white': true, 'rounded': false })
 * // returns 'px-2 py-1 bg-red-500 text-white'
 * 
 * cn('px-2', 'px-4') 
 * // returns 'px-4' (tailwind-merge handles the conflict)
 * 
 * @param {...string|Object} inputs - Class names or objects mapping class names to boolean values
 * @returns {string} - The merged class string
 */
export function cn(...inputs) {
  return twMerge(clsx(inputs));
} 